import { useEffect, useRef, useCallback } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import StatsBand from "@/components/site/StatsBand";
import Diagrams from "@/components/site/Diagrams";
import Demo from "@/components/site/Demo";
import Sectors from "@/components/site/Sectors";
import Pricing from "@/components/site/Pricing";
import Faq from "@/components/site/Faq";
import QuoteForm from "@/components/site/QuoteForm";
import Footer from "@/components/site/Footer";
import WhatsAppFloat from "@/components/site/WhatsAppFloat";

export const WHATSAPP_URL = `https://wa.me/35679029089?text=${encodeURIComponent(
  "Hi ThermoGlassPro — I'm interested in booking a free on-site demo."
)}`;

function App() {
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    lenisRef.current = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  const scrollTo = useCallback((id) => {
    if (lenisRef.current) {
      lenisRef.current.scrollTo(`#${id}`, { offset: -64, duration: 1.4 });
    }
  }, []);

  return (
    <div className="App bg-[#F8FAFC] text-slate-900">
      <Header onNavigate={scrollTo} />
      <main>
        <Hero onNavigate={scrollTo} />
        <StatsBand />
        <Diagrams />
        <Demo onNavigate={scrollTo} />
        <Sectors />
        <Pricing />
        <Faq />
        <QuoteForm />
      </main>
      <Footer />
      <WhatsAppFloat />
      <Toaster position="top-center" />
    </div>
  );
}

export default App;
